import gql from "graphql-tag";

export const VERIFY_PATIENT_REGISTRATION_TOKEN_QUERY = gql`
  query VerifyPatientRegistrationTokenQuery(
    $organisationHashId: String!
    $token: String!
  ) {
    verifyPatientRegistrationToken(
      organisationHashId: $organisationHashId
      token: $token
    ) {
      organisationName
      email
      isForChild
      firstName
      lastName
      dateOfBirth
      gender
      shippingName
      shippingLine1
      shippingLine2
      shippingCity
      shippingPostcode
      shippingCountry
      shippingPhoneNumber
      guardianFirstName
      guardianLastName
      guardianEmail
    }
  }
`;
